import { Coordinate } from './coordinate';

export class View {
  constructor(options) {
    ({
      zoomLevel: this.zoomLevel = 0,
      pan: this.pan = new Coordinate(),
      zoomPan: this.zoomPan = new Coordinate(),
      zoomMultiplier: this.zoomMultiplier = 0,
      pageCanvasOffset: this.pageCanvasOffset = new Coordinate(),
      canvasElement: this.canvasElement = null,
    } = options || {});
  }

  convertPageToGlobal(coordinate) {
    const local = new Coordinate(coordinate.x - this.pageCanvasOffset.x, coordinate.y - this.pageCanvasOffset.y);
    return this.convertLocalToGlobal(local);
  }

  convertPageToLocal(coordinate) {
    return new Coordinate(coordinate.x - this.pageCanvasOffset.x, coordinate.y - this.pageCanvasOffset.y);
  }

  convertLocalToGlobalDistance(distance) {
    const virtualStart = this.convertLocalToGlobal(new Coordinate());
    const virtualEnd = this.convertLocalToGlobal(new Coordinate(0, distance));
    return virtualStart.getFlattenPoint().distanceTo(virtualEnd.getFlattenPoint())[0];
  }

  convertGlobalToLocalDistance(distance) {
    const virtualStart = this.convertGlobalToLocal(new Coordinate());
    const virtualEnd = this.convertGlobalToLocal(new Coordinate(0, distance));
    return virtualStart.getFlattenPoint().distanceTo(virtualEnd.getFlattenPoint())[0];
  }

  convertGlobalToLocal(coordinate) {
    var newPoint = new Coordinate();
    newPoint.x = Math.round(coordinate.x * Math.pow(this.zoomMultiplier, this.zoomLevel) + this.pan.x + this.zoomPan.x);
    newPoint.y = Math.round(coordinate.y * Math.pow(this.zoomMultiplier, this.zoomLevel) + this.pan.y + this.zoomPan.y);
    return newPoint;
  }

  convertGlobalToLocalAll(coordinates) {
    return coordinates.map(coordinate => {
      return this.convertGlobalToLocal(coordinate);
    });
  }

  convertLocalToGlobal(coordinate) {
    const newPoint = new Coordinate();
    newPoint.x = Math.round(
      (coordinate.x - this.pan.x - this.zoomPan.x) * Math.pow(this.zoomMultiplier, -this.zoomLevel)
    );
    newPoint.y = Math.round(
      (coordinate.y - this.pan.y - this.zoomPan.y) * Math.pow(this.zoomMultiplier, -this.zoomLevel)
    );
    return newPoint;
  }

  convertLocalToGlobalAll(coordinates) {
    return coordinates.map(coordinate => {
      return this.convertLocalToGlobal(coordinate);
    });
  }

  zoomIn(zoomPoint) {
    const globalDiff = this.convertLocalToGlobal(zoomPoint);
    const diffs = this._getZoomDiffs(globalDiff);
    this.zoomLevel++;
    this.zoomPan.x += diffs.x;
    this.zoomPan.y += diffs.y;
  }

  zoomOut(zoomPoint) {
    this.zoomLevel--;
    const globalDiff = this.convertLocalToGlobal(zoomPoint);
    const diffs = this._getZoomDiffs(globalDiff);
    this.zoomPan.x -= diffs.x;
    this.zoomPan.y -= diffs.y;
  }

  move(oldPosition, newPosition) {
    const diffMouse = new Coordinate(oldPosition.x - newPosition.x, oldPosition.y - newPosition.y);

    this.pan.x += -diffMouse.x;
    this.pan.y += -diffMouse.y;
  }

  _getZoomDiffs(globalDiff) {
    const f = Math.pow(this.zoomMultiplier, this.zoomLevel) - Math.pow(this.zoomMultiplier, this.zoomLevel - 1.0);

    const diffX = -f * globalDiff.x;
    const diffY = -f * globalDiff.y;

    return {
      x: diffX,
      y: diffY,
    };
  }
}
